import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseHistoryBase from "@/pages/CaseHistory.Base.vue";

export default defineMosaicComponent<typeof CaseHistoryBase>("pages/CaseHistory");
